// @flow
/**
 * This function allows you determine whether a string matches
 * a RegExp partially. In other words, could this string
 * eventually match a given RegExp. This is useful for determining
 * if user input is valid as they are typing.
 *
 * This solution is an adapted version of the StackOverflow answer
 * here: https://stackoverflow.com/questions/22483214/regex-check-if-input-still-has-chances-to-become-matching/41580048#41580048
 */
export default (re: RegExp): RegExp => {
  let i = 0;
  const { source } = re;
  const process = () => {
    let result = '';
    let tmp: RegExp | RegExp$matchResult | number | null;

    const appendRaw = nbChars => {
      result += source.substr(i, nbChars);
      i += nbChars;
    };

    const appendOptional = nbChars => {
      result += `(?:${source.substr(i, nbChars)}|$)`;
      i += nbChars;
    };

    while (i < source.length) {
      switch (source[i]) {
        case '\\':
          switch (source[i + 1]) {
            case 'c':
              appendOptional(3);
              break;

            case 'x':
              appendOptional(4);
              break;

            case 'u':
              if (re.unicode) {
                if (source[i + 2] === '{') {
                  appendOptional(source.indexOf('}', i) - i + 1);
                } else {
                  appendOptional(6);
                }
              } else {
                appendOptional(2);
              }
              break;

            default:
              appendOptional(2);
              break;
          }
          break;

        case '[':
          tmp = /\[(?:\\.|.)*?\]/g;
          tmp.lastIndex = i;
          tmp = tmp.exec(source);
          if (tmp) {
            appendOptional(tmp[0].length);
          }
          break;

        case '|':
        case '^':
        case '$':
        case '*':
        case '+':
        case '?':
          appendRaw(1);
          break;

        case '{':
          tmp = /\{\d+,?\d*\}/g;
          tmp.lastIndex = i;
          tmp = tmp.exec(source);
          if (tmp) {
            appendRaw(tmp[0].length);
          } else {
            appendOptional(1);
          }
          break;

        case '(':
          if (source[i + 1] === '?') {
            switch (source[i + 2]) {
              case ':':
                result += '(?:';
                i += 3;
                result += `${process()}|$)`;
                break;

              case '=':
                result += '(?=';
                i += 3;
                result += `${process()})`;
                break;

              case '!':
                tmp = i;
                i += 3;
                process();
                result += source.substr(tmp, i - tmp);
                break;
              default:
                break;
            }
          } else {
            appendRaw(1);
            result += `${process()}|$)`;
          }
          break;

        case ')':
          i += 1;
          return result;

        default:
          appendOptional(1);
          break;
      }
    }

    return result;
  };

  return new RegExp(process(), re.flags);
};



// WEBPACK FOOTER //
// ../utilities/partialRegExp.js